import React from 'react'
import { CrossClientRunningExecutionsPoller } from './CrossClientRunningExecutionsPoller'
import { useAppSelector } from '../../../../store/hooks'
import { selectCrossClientRunningExecutions } from '../../../../store/crossClient/crossClientLanding'
import { LinkButton } from '../../../../components/Button/LinkButton'
import classnames from 'classnames'
import moment from 'moment'

export const CrossClientRunningExecutions: React.FC = () => {
  const runningExecutions = useAppSelector(selectCrossClientRunningExecutions)

  return (
    <>
      <CrossClientRunningExecutionsPoller />
      <div className='card border-0 shadow-sm rounded-3 p-4'>
        <div className='d-flex justify-content-between align-items-center mb-3 gap-3'>
          <h5 className='card-title mb-0'>
            <i className='bi bi-lightning-charge-fill zocks-text-primary me-2'></i>
            Running Queries
            {runningExecutions.length > 0 && <span className='badge bg-primary rounded-pill ms-2'>{runningExecutions.length}</span>}
          </h5>
          <small className='text-muted'>Last updated: {moment().format('HH:mm:ss')}</small>
        </div>

        <div className='card-body p-0'>
          {!runningExecutions.length ? (
            <div className='d-flex flex-column align-items-center justify-content-center py-4 text-muted'>
              <i className='bi bi-database-slash fs-1 mb-2'></i>
              <p>No running queries at the moment</p>
            </div>
          ) : (
            <div className='list-group list-group-flush'>
              {runningExecutions.map((execution, index) => (
                <div
                  key={execution.id}
                  className={classnames('list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3 gap-4', {
                    'border-top': index !== 0,
                  })}
                >
                  <div className='d-flex flex-column'>
                    <div className='fw-bold text-truncate' style={{ maxWidth: '500px' }} title={execution.userQuestion}>
                      {execution.userQuestion}
                    </div>
                    <small className='text-muted'>Query ID: {execution.id.substring(0, 8)}...</small>
                  </div>
                  <LinkButton variant='primary' className='rounded-pill d-flex align-items-center' to={`/cross-client/executions/${execution.id}`}>
                    <i className='bi bi-arrow-right-circle me-2'></i>
                    View Details
                  </LinkButton>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  )
}
